import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { CalendarOutlined } from "@ant-design/icons";

const DoctorList = ({ doctor, selectedDoctorId, handleSelectDoctor }) => {
  const navigate = useNavigate();
  const isSelected = selectedDoctorId === doctor._id;
  const handleButtonClick = () => {
    handleSelectDoctor(doctor._id);
  };

  return (
    <>
      <Button
        type={isSelected ? "primary" : "default"}
        onClick={() => {
          handleButtonClick();
          navigate(`/doctor/book-appointment/${doctor._id}`);
        }}
        icon={<CalendarOutlined />}
        style={{ maxWidth: 'auto', marginBottom: '8px' }}
      >
        <b> {doctor.firstName} Book Appointment</b>
      </Button>

    </>
  );
};

export default DoctorList;

